/* eslint-disable no-console */

import { register } from 'register-service-worker'

var vueAppBaseUrl =
    document.getElementById('app').getAttribute('vueappbaseurl') ||
    process.env.VUE_APP_BASE_URL

var path =
    process.env.VUE_APP_STANDALONE == 'true'
        ? ''
        : '/wp-content/plugins/bouge-io/content/dist'

if (process.env.NODE_ENV === 'production') {
    register(`${vueAppBaseUrl}${path}/firebase-messaging-sw.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('New content is available; please refresh.')
        },
        offline() {
            console.log(
                'No internet connection found. App is running in offline mode.'
            )
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })

    register(`${vueAppBaseUrl}/firebase-messaging-sw.js`)
}
